import React from "react";
import { InstagramIcon } from "./InstagramIcon";
import { LOGO_URL, MOTTO_LINES, contactInfo, navLinks, whatsappNumbers } from "../data/content";
export function Footer() {
  return <footer className="bg-ink text-paper" data-id="element-105" data-mp="32o4cmezogg8n">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8" data-id="element-106" data-mp="32pffmclatjyp">
        <div className="grid gap-14 lg:grid-cols-[1.5fr_1fr_1fr]" data-id="element-107" data-mp="36oy1baky1z2l">
          <div data-id="element-108" data-mp="36n3cvmagrotr">
            <div className="flex items-center gap-3" data-id="element-109" data-mp="3ufa3s5xf73ls">
              <img src={LOGO_URL} alt="" className="h-16 w-16 object-contain mix-blend-lighten" data-id="element-110" data-mp="3ufjvbxy45itl" />
              <span className="leading-tight" data-id="element-111" data-mp="387fbm8yvbf9">
                <span className="block text-lg font-semibold tracking-wide" data-id="element-112" data-mp="3lelzw41qqjmm">FORTIS</span>
                <span className="block text-xs tracking-[0.18em] text-gold" data-id="element-113" data-mp="3qdf2h1fhoq80">SPORTS MANAGEMENT</span>
              </span>
            </div>
            <p className="mt-8 max-w-sm italic leading-relaxed text-paper/75" data-id="element-114" data-mp="29y5hc1uw3mvj">
              {MOTTO_LINES.map(line => <span key={line} className="block" data-id="element-115" data-mp="2ezurlfaafwik">
                  {line}
                </span>)}
            </p>
          </div>

          <nav aria-label="Pie de página" data-id="element-116" data-mp="3gapcti26iifg">
            <ul className="space-y-3" data-id="element-117" data-mp="3gc0f1dfz7i4g">
              {navLinks.map(link => <li key={link.href} data-id="element-118" data-mp="3v8rfzr5at1w6">
                  <a href={link.href} className="text-paper/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-119" data-mp="3v5n7ihksvjzp">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-120" data-mp="80ntcj7a4qcv">
                <a href={contactInfo.transfermarktUrl} target="_blank" rel="noopener noreferrer" className="text-paper/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-121" data-mp="3477xwrgsq3h">
                  Jugadores en Transfermarkt
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-122" data-mp="mrwqdddihe01">
            <h2 className="text-sm font-semibold text-gold" data-id="element-123" data-mp="msg8ov72q4el">Contacto</h2>
            <ul className="mt-5 space-y-3 text-paper/75" data-id="element-124" data-mp="mq3hrsjc8jpe">
              {whatsappNumbers.map(number => <li key={number.url} data-id="element-125" data-mp="yu7ictvibtz9">
                  <a href={number.url} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-126" data-mp="yv93jr68lwup">
                    WhatsApp: {number.display}
                  </a>
                </li>)}
              <li data-id="element-127" data-mp="1hkp5mixklxd8">
                <a href={`mailto:${contactInfo.email}`} className="break-all transition-colors duration-150 ease-out hover:text-gold" data-id="element-128" data-mp="1hk5ylx9gktdz">
                  {contactInfo.email}
                </a>
              </li>
              <li data-id="element-129" data-mp="1rj4zuurw9mqy">
                <a href={contactInfo.instagramUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-gold" data-id="element-130" data-mp="1rhk5b55ky3t3">
                  <InstagramIcon className="h-4 w-4" data-id="element-131" data-mp="2afdmnov6vuul" />
                  Instagram: {contactInfo.instagramHandle}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-ink-line pt-8 text-sm text-paper/55" data-id="element-132" data-mp="21m0kdwb8jgvu">
          © {new Date().getFullYear()} Fortis Sports Management. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}